import { useEffect, useRef } from 'react'
import { LicensesModel, StateIdModel } from '../models/LicensesModel'

const MAX_RELOADS_COUNT = 10
const RELOAD_TIMEOUT_SEC = 10

export const useLicenseAutoReload = (
  licenses: LicensesModel | null,
  onReload: (isHideLoading: boolean) => void,
  maxReloads = MAX_RELOADS_COUNT,
) => {
  const reloadCountRef = useRef(0)

  useEffect(() => {
    if (!licenses?.collection) {
      return
    }

    const hasCreationLicenses = licenses.collection.some(
      license => license.stateId === StateIdModel.CREATION,
    )

    if (hasCreationLicenses && reloadCountRef.current < maxReloads) {
      const timer = setTimeout(() => {
        onReload(true)
        reloadCountRef.current += 1
      }, RELOAD_TIMEOUT_SEC * 1000)

      return () => clearTimeout(timer)
    }
  }, [licenses, onReload, maxReloads])

  // Reset counter when no CREATION licenses exist
  useEffect(() => {
    if (licenses?.collection) {
      const hasCreationLicenses = licenses.collection.some(
        license => license.stateId === StateIdModel.CREATION,
      )

      if (!hasCreationLicenses) {
        reloadCountRef.current = 0
      }
    }
  }, [licenses])
}
